export default class CodecService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/codecs', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/codecs', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/codecs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/CodecService.js